// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"5":"home-desktop-taxonomy-css","671":"home-desktop-taxonomy","939":"browse-card-ui"}[chunkId] || chunkId) + "-" + {"5":"74de1ac064","289":"e9a52fe4d2","671":"aba6f47524","939":"585790e5ef"}[chunkId] + ".js";
};